export default {
    onShareAppMessage () {
        return this.getShareInfo({
            title: `你的公积金贷款额度是多少？点击立即了解~`,
            path: `/pages/packageB/provident_fund/main`,
            imageUrl: 'https://cdn.vip-wifi.com/fangchan/img/packageB/provident_fund/share.png'
        })
    }
}
